export const ErrorCode: { [key: string]: string } = {
  '200': 'SUCCESS',
  '400': 'BAD_REQUEST',
  '401': 'UNAUTHORIZED',
  '403': 'FORBIDDEN',
  '404': 'NOT_FOUND',
  '405': 'METHOD_NOT_ALLOWED',
  '406': 'NOT_ACCEPTABLE',
  '415': 'UNSUPPORTED_MEDIA_TYPE',
  '500': 'INTERNAL_SERVER_ERROR',
  '1000': 'NOT_PERMISSION',
  '1001': 'INVALID_TOKEN',
  '1002': 'NOT_FOUND_USER',
  '1003': 'NOT_FOUND_FILE',
  '1004': 'NOT_FOUND_JOB',
  '1005': 'INVALID_FILE_NAME',
  '1006': 'ALREADY_EXIST_FILE',
  '1007': 'PACS_NOT_REGISTED_AET',
  '1008': 'MORE_REGISTED_PATIENT_ID',
  '1009': 'ALREADY_REQUEST_ANALYSIS',
  '1010': 'PACS_CSTORE_ERROR',
  '1011': 'FILE_SAVE_ERROR',
  '1012': 'USED_USER_ID',
  '1013': 'NOT_MATCH_PASSWORD',
  '1014': 'INVALID_LICENSE_KEY',
  '1015': 'UNAVAILABLE_LICENSE',
  '1016': 'MUST_HAVE_DATE_IF_NOT_AUTO_ACTIVATE',
  '1017': 'ALREADY_REGISTERED_LICENSE',
  '1018': 'NOT_FOUND_COMPANY',
  '1019': 'LOGIN_FAIL',
  '1020': 'NOT_FOUND_LICENSE',
  '1021': 'CAPTCHA_FAIL',
  '1022': 'NOT_FOUND_WORKLIST',
  '1023': 'NOT_FOUND_WORKLIST_ID',
  '1024': 'NOT_FOUND_FILE_PATH',
  '1025': 'FAILED_IMAGE_TRANSFER_TO_PACS',
  '1026': 'NOT_MATCH_IMAGE_FORMAT',
  '1027': 'DIRECTORY_CREATE_FAIL',
  '1028': 'NOT_EXIST_TAG',
  '1029': 'NOT_EXIST_AUTHENTICATION_INFO',
  '1030': 'REPORT_CONVERT_FAIL',
  '1031': 'NODE_SERVER_ERROR',
  '1032': 'CONTACT_SYSTEM_ADMINISTRATOR',
  '1033': 'INVALID_MOBILE_NUMBER',
  '1034': 'NOT_MATCH_MOBILE_NUMBER',
  '1035': 'NOT_FOUND_OTP',
  '1036': 'EXPIRED_LICENSE',
  '1037': 'UNABLE_STATUS',
  '1038': 'CANNOT_BE_DELETED',
  '1039': 'INVALID_USER_ACTIVE_DATE',
  '1040': 'EXPIRED_ACCOUNT',
  '1041': 'ONLY_ONE_WAITING_LICENSE_ACCEPTABLE',
  '1042': 'INVALID_LICENSE_STATUS_FOR_CLOSE',
  '1043': 'NOT_FOUND_LICENSE_FOR_CLOSE',
  '1044': 'FULL_OF_ACTIVATED_USERS',
  '1045': 'INVALID_OTP_TOKEN',
  '1046': 'PERMISSION_DENIED_FOR_READ',
  '1047': 'PERMISSION_DENIED_FOR_DELETE',
  '1048': 'NOT_FOUND_COMPANY_IN_PRODUCT_ADMIN',
  '1049': 'NO_EMAIL_SERVER_AVAILABLE',
  '1050': 'REPORT_DOWNLOAD_FAILED',
  '1051': 'MAKE_ZIP_FILE_FAILED',
  '1052': 'NOT_FOUND_PACS',
  '1053': 'SAVE_FAILED_FOR_CHECK_SOP_UID',
  '1054': 'MUST_BE_DIFFERENT_PASSWORD',
  '1056': 'DELETED_USER_ID',
  '1057': 'INVALID_VALIDATION_TAG',
  '1058': 'COPY_FILE_FAILED',
  '1059': 'MAIL_SEND_TEST_FAIL',
  '1060': 'INVALID_DICOM_TAG',

  '1061': 'ILLEGAL_ARGUMENT_ERROR',
  '1062': 'EXCEL_DOWNLOAD_ERROR',
  '1063': 'DEACTIVATED_USER',
  '1064': 'DUPLICATED_LOGIN',
  '1065': 'EXPIRED_SESSION',
  '1066': 'NOT_DEFINED_REPORT_HANDLER',
  '1067': 'NOT_PROVIDE_THIS_FEATURE',
  '1068': 'NOT_FOUND_SETTING',
  '1069': 'NOT_FOUND_NOTIFICATION_SETTING',
  '1070': 'INVALID_REQUEST',
  '1071': 'FAILED_READ_DICOM_TAG',
  '1072': 'NOT_FOUND_PRODUCT',
  '1073': 'CANNOT_BE_DELETED_FOR_EXIST_LICENSE',
  '1074': 'UNABLE_TO_REANALYZE',
  '1075': 'NOT_FOUND_AIF_VOF_DATA',
  '1076': 'NOT_FOUND_COLORMAP_DATA',
  '1077': 'TOO_MANY_REGISTERED_COMPANY',

  '1078': 'STOP_ANALYSIS',

  '1079': 'IMAGE_DOWNLOAD_FAIL',
  '1080': 'UNSUPPORTED_FEATURES',
  '1081': 'IMAGE_CONVERSION_FAIL',
  '1082': 'CANNOT_CANCEL_WORKLIST',
  '1083': 'CANNOT_DELETE_COMPANY_BY_EXIST_LICENSE',
  '1084': 'PERMISSION_DENIED_FOR_TRANSFER',
  '1085': 'INVALID_SIGNATURE',
  '1086': 'USER_LOCKED',
  '1087': 'UNLOCK_FAIL',

  '2000': 'EMPTY_USER_ID',
  '2001': 'EMPTY_PASSWORD',
  '2002': 'EMPTY_PASSWORD_HINT_QUESTION',
  '2003': 'EMPTY_PASSWORD_HINT_ANSWER',
  '2004': 'EMPTY_FIRST_NAME',
  '2005': 'EMPTY_LAST_NAME',
  '2006': 'EMPTY_BIRTHDAY',
  '2007': 'EMPTY_POSITION',
  '2008': 'EMPTY_EMAIL',
  '2009': 'EMPTY_CURRENT_PASSWORD',
  '2010': 'EMPTY_NEW_PASSWORD',
  '2011': 'INVALID_USER_ID',
  '2012': 'INVALID_PASSWORD',
  '2013': 'INVALID_FIRST_NAME',
  '2014': 'INVALID_LAST_NAME',
  '2015': 'INVALID_EMAIL',
  '2016': 'CHECK_SIZE_USER_ID',
  '2017': 'CHECK_SIZE_PASSWORD',
  '2018': 'CHECK_SIZE_FIRST_NAME',
  '2019': 'CHECK_SIZE_LAST_NAME',
  '2020': 'CHECK_SIZE_PASSWORD_HINT_QUESTION',
  '2021': 'CHECK_SIZE_PASSWORD_HINT_ANSWER',
  '2022': 'EMPTY_LANGUAGE',
  '2023': 'EMPTY_IMAGE_FILE',
  '2024': 'EMPTY_AUTO_LOCK',
  '2025': 'EMPTY_AUTO_LOCK_DURATION',
  '2026': 'INVALID_AUTO_LOCK',
  '2027': 'INVALID_PACS_PROTOCOL',
  '2028': 'PATIENT_BIRTH_DATE',
  '2029': 'STUDY_INSTANCE_UID',
  '2030': 'SERIES_INSTANCE_UID',
  '2031': 'ACQUISITION_DATE',
  '2032': 'IMAGES',
  '2033': 'PATIENT_ID',
  '2034': 'PATIENT_NAME',
  '2035': 'PATIENT_SEX',
  '2036': 'PATIENT_AGE',
  '2037': 'EMPTY_MOBILE_NUMBER',
  '2038': 'EMPTY_STUDY_DATE',
  '2039': 'EMPTY_SET_ID',
  '2040': 'EMPTY_WORKLIST_ID',
  '2041': 'EMPTY_SERIES_DATE',
  '2042': 'EMPTY_ORDER',
  '2043': 'EMPTY_LICENSE_ID',
  '2044': 'EMPTY_LICENSE_CODE',
  '2045': 'CHECK_SIZE_LICENSE_CODE',
  '2046': 'EMPTY_AUTO_ACTIVATE',
  '2047': 'EMPTY_PACS_AET',
  '2048': 'EMPTY_PACS_IP_ADDRESS',
  '2049': 'EMPTY_PACS_PORT',
  '2050': 'INVALID_PACS_PORT',
  '2051': 'EMPTY_ACTIVATED',
  '2052': 'EMPTY_FROM_DATE',
  '2053': 'EMPTY_TO_DATE',
  '2054': 'INVALID_ACCOUNT_TO_DATE',
  '2055': 'EMPTY_FILE_EXT',
  '2056': 'INVALID_SUPPORT_PDF',
  '2057': 'INVALID_SUPPORT_TYPE',
  '2058': 'EMPTY_CONTENT',
  '2059': 'EMPTY_EMAIL_SERVER_HOST',
  '2060': 'EMPTY_EMAIL_SERVER_PORT',
  '2061': 'EMPTY_EMAIL_SENDER_NAME',
  '2062': 'EMPTY_EMAIL_SENDER_ADDRESS',
  '2063': 'INVALID_EMAIL_SERVER_PORT',
  '2064': 'DUPLICATE_PACS_INFOMATION',
  '2067': 'EMPTY_IMAGE_ORIENTATION',
  '2068': 'EMPTY_VALIDATION_TAG',
  '2069': 'EMPTY_VALIDATION_TAG_VALUE',
  '2070': 'INVALID_DICOM_TAG',
  '2071': 'INVALID_PASSWORD_PATTERN',
  '2072': 'EMPTY_ANONYMIZATION_TYPE',
  '2073': 'EMPTY_COMPANY_NAME',
  '2074': 'CHECK_SIZE_COMPANY_NAME',
  '2075': 'ALREADY_REGISTERED_COMPANY_ID',
  '2076': 'INVALID_PATIENT_AGE',

  '2077': 'INVALID_ESSENTIAL_TAG',
  '2078': 'EMPTY_TO_ADDRESS',
  '2079': 'NOT_DEFINED_EMAIL_SENDER',

  '2080': 'AT_LEAST_ONE',
  '2081': 'EMPTY_STORAGE_PERIOD',
  '2082': 'INVALID_PRODUCT_CODE',
  '2083': 'PACS_DUPLICATE_DATA',
  '2084': 'PACS_INCONSISTENT_BIRTHDATE',
  '2085': 'EMPTY_DATE_FORMAT',
  '2086': 'EMPTY_ENCODING',
  '2087': 'EMPTY_IS_SEQUENTIAL',
  '2088': 'EMPTY_RELAY_PACS_REPORT',
  '2089': 'INVALID_DATE_FORMAT',
  '2090': 'STORAGE_ALMOST_FULL',
  '2091': 'INVALID_TO_PACS',
  '2092': 'INVALID_FROM_PACS',
  '2093': 'INVALID_FILE_COUNT',
  '2094': 'EMPTY_COMPANY_ID',
  '2095': 'EMPTY_REPORT_URL',
  '2096': 'EMPTY_SCREENSHOT_URL',
  '2097': 'EMPTY_CALLBACK_URL',
  '2098': 'NOT_FOUND_MESSENGER_INFO',
  '2099': 'INVALID_TIMEZONE',
  '2100': 'ALREADY_TRANSFERRED_WORKLIST',
  '2101': 'NOT_COMPLETED_WORKLIST_TRANSFER',
  '2102': 'INVALID_TRANSFER_COMPANY_ID',
  '2103': 'INVALID_DEVICE_TYPE',
  '2104': 'INVALID_ATTECH_FILE',
  '2105': 'NOT_COMPLETED_WORKLIST',
  '2106': 'INVALID_ENCODING',
  '2107': 'INVALID_FILE_FORMAT',
  '2108': 'INVALID_LANGUAGE',
  '2109': 'INVALID_OTP',
  '2110': 'NOT_SETTING_PROTOCOL_TAG',
  '2111': 'INVALID_PROTOCAL_TAG',
  '2112': 'INPUT_SERIES_TO_MANY',

  '5000': 'NO_RESULT_FILE_RECEIVED',
  '5001': 'ENGINE_EXPIRED_LICENSE',
  '5002': 'INTERNAL_ERROR',
  '5003': 'PREPROCESS_FAILED',
  '5004': 'ANALYSIS_FAILED',
  '5005': 'FAIL_UPLOAD_FAILED',
  '5006': 'GPU_OUT_OF_MEMORY',
  '5010': 'SEGMENTATION_ERROR',
  '5011': 'INCORRECT_INPUT_IMAGE',

  '5012': 'FOUR_D_IMAGE_NOT_SUPPORTED',
  '5013': 'INCONSISTENCY_IN_NIFTI_HEADER',
  '5014': 'FOV_IS_GREATER_THAN_256MM',
  '5015': 'HIPPOCAMPUS_IS_NOT_RECOGNIZED',
  '5016': 'INSTALLATION_ERROR',
  '5017': 'INPUT_DATA_ERROR',
  '5018': 'OPERATION_ERROR',
  '5019': 'LONGITUDINAL_OPERATION_ERROR',

  '5020': 'IMAGE_FILE_LOAD_FAIL',
  '5021': 'INIT_FAIL',
  '5022': 'DATA_NOT_APPROPRIATE',
  '5023': 'PARTIAL_SEGMENTATION_ERROR',
  '5024': 'THICKNESS_ERROR',
  '5025': 'PARTIAL_SEGMENTATION_ERROR_ONLY_VOLUME',
  '5026': 'THICKNESS_ERROR_ADD_THICK',
  '5027': 'NOT_HEURON_SMWI',
  '9999': 'UNDEFINED_CODE',
};

export const ErrorMessage: { [key: string]: string } = {
  BAD_REQUEST: 'Bad Request',
  UNAUTHORIZED: 'Unauthorized',
  FORBIDDEN: 'Forbidden',
  NOT_FOUND: 'Not Found',
  METHOD_NOT_ALLOWED: 'Method Not Allowed',
  NOT_ACCEPTABLE: 'Not Acceptable',
  UNSUPPORTED_MEDIA_TYPE: 'Unsupported Media Type',
  INTERNAL_SERVER_ERROR: 'Internal Server Error',
  NOT_PERMISSION: `You don't have permission to access.`,
  INVALID_TOKEN: `Token permission information does not exist.`,
  NOT_FOUND_USER: `There are no matching members.`,
  NOT_FOUND_FILE: `The file does not exist.`,
  NOT_FOUND_JOB: `The job does not exist.`,
  INVALID_FILE_NAME: `It contains invalid characters.`,
  ALREADY_EXIST_FILE: `The file already exist.`,
  PACS_NOT_REGISTED_AET: `There are no registered AET.`,
  MORE_REGISTED_PATIENT_ID: `1 or more patientID registered.`,
  ALREADY_REQUEST_ANALYSIS: `Analysis has already been requested or completed.`,
  PACS_CSTORE_ERROR: 'Error has occurred while PACS cStored',
  FILE_SAVE_ERROR: `There was an error saving the image.`,
  USED_USER_ID: `In used ID.`,
  NOT_MATCH_PASSWORD: `Password does not match.`,
  INVALID_LICENSE_KEY: `Invalid License code.`,
  UNAVAILABLE_LICENSE: `There are no licenses available.`,
  MUST_HAVE_DATE_IF_NOT_AUTO_ACTIVATE: `Set the start date.`,
  ALREADY_REGISTERED_LICENSE: `This License code has already been registerd.`,
  NOT_FOUND_COMPANY: `The company does not match.`,
  LOGIN_FAIL: `Signin failed.`,
  NOT_FOUND_LICENSE: `The license does not match.`,
  CAPTCHA_FAIL: `Authentication failed.`,
  NOT_FOUND_WORKLIST: `Worklist does not exist.`,
  NOT_FOUND_WORKLIST_ID: `Worklist ID does not exist.`,
  NOT_FOUND_FILE_PATH: `The file path does not exist.`,
  FAILED_IMAGE_TRANSFER_TO_PACS: `Image transfer failed to PACS.`,
  NOT_MATCH_IMAGE_FORMAT: `Check the image(jpeg) format.`,
  DIRECTORY_CREATE_FAIL: `Failed to create directory.`,
  NOT_EXIST_TAG: `The tag does not exist.`,
  NOT_EXIST_AUTHENTICATION_INFO: `Authentication information does not exist.`,
  REPORT_CONVERT_FAIL: `Report conversion failed.`,
  NODE_SERVER_ERROR: `Node server error.`,
  CONTACT_SYSTEM_ADMINISTRATOR: `Contact your administrator.`,
  INVALID_MOBILE_NUMBER: `Invalid mobile number.`,
  NOT_MATCH_MOBILE_NUMBER: `The registered phone number does not match.`,
  NOT_FOUND_OTP: `The OTP token does not exist.`,
  EXPIRED_LICENSE: `Expired license.`,
  UNABLE_STATUS: `Unable to proceed.`,
  CANNOT_BE_DELETED: `Cannot be deleted worklist.`,
  INVALID_USER_ACTIVE_DATE: `Invalid account activation date.`,
  EXPIRED_ACCOUNT: `Expired account.`,
  ONLY_ONE_WAITING_LICENSE_ACCEPTABLE: `Register only one pending license.`,
  INVALID_LICENSE_STATUS_FOR_CLOSE: `License cannot be terminated.`,
  NOT_FOUND_LICENSE_FOR_CLOSE: `License does not exist.`,
  FULL_OF_ACTIVATED_USERS: `"The number of active accounts has been exceeded.\nPlease deactivate some accounts."`,
  INVALID_OTP_TOKEN: `Invalid verification code. Get verification code again.`,
  PERMISSION_DENIED_FOR_READ: `You don't have permission to read.`,
  PERMISSION_DENIED_FOR_DELETE: `You don't have permission to delete.`,
  NOT_FOUND_COMPANY_IN_PRODUCT_ADMIN: 'The company does not exist in product admin.',
  NO_EMAIL_SERVER_AVAILABLE: '이메일 서버가 설정되이 있지 않습니다.',
  REPORT_DOWNLOAD_FAILED: '리포트 다운로드 실패',
  MAKE_ZIP_FILE_FAILED: 'Zip 파일 생성 실패',
  NOT_FOUND_PACS: 'PACS를 찾을 수 없습니다.',
  SAVE_FAILED_FOR_CHECK_SOP_UID: '동일 이미지의 종적 분석을 위한 데이터를 받는중입니다. 잠시 후 다시 요청해주세요.',
  MUST_BE_DIFFERENT_PASSWORD: '동일한 패스워드입니다.',
  DELETED_USER_ID: '삭제된 유저 아이디 입니다.',
  INVALID_VALIDATION_TAG: '태그 파라미터가 유효하지 않습니다.',
  COPY_FILE_FAILED: '파일 카피 실패',
  MAIL_SEND_TEST_FAIL: '메일 전송 테스트 실패',
  INVALID_DICOM_TAG: 'Invalid dicom tag.',
  EMPTY_USER_ID: `Please enter the ID.`,
  EMPTY_PASSWORD: `Please enter the Password.`,
  EMPTY_PASSWORD_HINT_QUESTION: '비밀번호 힌트를 입력해주세요.',
  EMPTY_PASSWORD_HINT_ANSWER: '생년월일을 입력해주세요.',
  EMPTY_FIRST_NAME: `Please enter the first name.`,
  EMPTY_LAST_NAME: `Please enter the last name.`,
  EMPTY_BIRTHDAY: '생년월일을 입력해주세요.',
  EMPTY_POSITION: '직급을 입력해주세요.',
  EMPTY_EMAIL: `Please enter the email address.`,
  EMPTY_CURRENT_PASSWORD: `Please enter the current password.`,
  EMPTY_NEW_PASSWORD: `Please enter the new password.`,
  INVALID_USER_ID: `Please enter the valid ID.`,
  INVALID_PASSWORD: `Current password incorrect.`,
  INVALID_FIRST_NAME: `Please enter the valid first name.`,
  INVALID_LAST_NAME: `Please enter the valid last name.`,
  INVALID_EMAIL: `Please enter the valid email address.`,
  CHECK_SIZE_USER_ID: `Use 3 or more characters.`,
  CHECK_SIZE_PASSWORD: `Current password incorrect.`,
  CHECK_SIZE_FIRST_NAME: `Use no more than 20 characters.`,
  CHECK_SIZE_LAST_NAME: `Use no more than 20 characters.`,
  CHECK_SIZE_PASSWORD_HINT_QUESTION: '비밀번호 힌트 질문을 20자 이내로 입력해주세요.',
  CHECK_SIZE_PASSWORD_HINT_ANSWER: '비밀번호 힌트 답변을 20자 이내로 입력해주세요.',
  EMPTY_LANGUAGE: '설정 언어를 입력해주세요.',
  EMPTY_IMAGE_FILE: `Dicom File does not exist.`,
  EMPTY_AUTO_LOCK: ` '잠금 여부를 입력해주세요.'`,
  EMPTY_AUTO_LOCK_DURATION: ` '잠금 시간을 입력해주세요.'`,
  INVALID_AUTO_LOCK: ` '유효한 잠금 여부가 아닙니다.'`,
  INVALID_PACS_PROTOCOL: `Invalid protocol.`,
  PATIENT_BIRTH_DATE: `Please enter the patient's birthday.`,
  STUDY_INSTANCE_UID: `Please check the patient's study instance uid.`,
  SERIES_INSTANCE_UID: `Please check the patient's series instance uid.`,

  ILLEGAL_ARGUMENT_ERROR: 'Invalid argument value.',
  EXCEL_DOWNLOAD_ERROR: 'Excel download error.',
  DEACTIVATED_USER: 'Your account has been deactivated. \nSign in again.',
  DUPLICATED_LOGIN:
    'Your account has been signed out, \nbecause duplicate logins have been detected. \nPlease sign in again.',
  EXPIRED_SESSION: 'Session has ended. Please sign in again.',
  NOT_DEFINED_REPORT_HANDLER: 'Report generation handler is not defined.',
  NOT_PROVIDE_THIS_FEATURE: 'Function not provided.',
  NOT_FOUND_SETTING: 'Setting does not exists.',
  NOT_FOUND_NOTIFICATION_SETTING: 'Notification setting does not exists.',
  INVALID_REQUEST: 'Invalid request.',
  FAILED_READ_DICOM_TAG: 'Failed to read DICOM tags.',
  NOT_FOUND_PRODUCT: 'The product does not exists.',
  CANNOT_BE_DELETED_FOR_EXIST_LICENSE: 'A generated license already exists.',
  UNABLE_TO_REANALYZE: 'Unable to reanalyze.',
  NOT_FOUND_AIF_VOF_DATA: 'AIF/VOF info does not exists.',
  NOT_FOUND_COLORMAP_DATA: 'COLORMAP info does not exists.',
  TOO_MANY_REGISTERED_COMPANY: 'Only one corporation can be registered.',

  STOP_ANALYSIS: 'Stop Analysis.',

  IMAGE_DOWNLOAD_FAIL: 'Failed to download the image.',
  UNSUPPORTED_FEATURES: 'This function is not supported.',
  IMAGE_CONVERSION_FAIL: 'Failed to image conversion.',
  CANNOT_CANCEL_WORKLIST: 'Analysis cancellation unsuccessful.',
  CANNOT_DELETE_COMPANY_BY_EXIST_LICENSE: '이 고객의 라이선스가 등록되어 있어 삭제할 수 없습니다.',
  PERMISSION_DENIED_FOR_TRANSFER: 'You do not have permission to transfer.',
  INVALID_SIGNATURE: '유효하지 않은 서명 입니다.',
  USER_LOCKED: '사용자가 LockMode 상태입니다.',
  UNLOCK_FAIL: 'Unlock failed.	Unlock failed.',

  ACQUISITION_DATE: `Please check the date of shooting.`,
  IMAGES: `Please enter the image information.`,
  PATIENT_ID: `Please enter the patient's ID.`,
  PATIENT_NAME: `Please enter the patient's name.`,
  PATIENT_SEX: `Please enter the patient's gender.`,
  PATIENT_AGE: `Please enter the patient's age.`,
  EMPTY_MOBILE_NUMBER: `Please enter the phone number.`,
  EMPTY_STUDY_DATE: `Please enter the patient's study date.`,
  EMPTY_SET_ID: `Worklist set ID does not exist.`,
  EMPTY_WORKLIST_ID: `Worklist ID does not exist.`,
  EMPTY_SERIES_DATE: `Series date does not exist.`,
  EMPTY_ORDER: `Order number does not exist.`,
  EMPTY_LICENSE_ID: `Please enter the license ID.`,
  EMPTY_LICENSE_CODE: `Please enter the license code.`,
  CHECK_SIZE_LICENSE_CODE: `Please enter the license code between 10 and 100 characters.`,
  EMPTY_AUTO_ACTIVATE: `Please select activate type.`,
  EMPTY_PACS_AET: `Please enter the PACS AE Title.`,
  EMPTY_PACS_IP_ADDRESS: `Please enter the PACS IP.`,
  EMPTY_PACS_PORT: `Please enter the PACS port.`,
  INVALID_PACS_PORT: `Invalid PACS port.`,
  EMPTY_ACTIVATED: `Please select the account activate type.`,
  EMPTY_FROM_DATE: '유효 시작일을 입력해주세요.',
  EMPTY_TO_DATE: `Please enter the account expiration date.`,
  INVALID_ACCOUNT_TO_DATE: `Account expiration date must be set after today.`,
  EMPTY_FILE_EXT: `Please enter the file format.`,
  INVALID_SUPPORT_PDF: 'Invalid PDF file.',
  INVALID_SUPPORT_TYPE: 'Invalid Inquiry classification.',
  EMPTY_CONTENT: 'Please enter the contents.',
  EMPTY_EMAIL_SERVER_HOST: 'Please enter the email server host.',
  EMPTY_EMAIL_SERVER_PORT: 'Please enter the email server port.',
  EMPTY_EMAIL_SENDER_NAME: 'Please enter the sender of the email server.',
  EMPTY_EMAIL_SENDER_ADDRESS: 'Please enter the sender address of the email server.',
  INVALID_EMAIL_SERVER_PORT: 'Invalid email server port.',
  DUPLICATE_PACS_INFOMATION: 'IP and AET must be unique.',
  EMPTY_IMAGE_ORIENTATION: 'Please enter the image orientation.',
  EMPTY_VALIDATION_TAG: 'Please enter the validation tag.',
  EMPTY_VALIDATION_TAG_VALUE: 'Please enter the validation tag value',

  INVALID_PASSWORD_PATTERN: 'Invalid password.',
  EMPTY_ANONYMIZATION_TYPE: 'Enter anonymization type.',
  EMPTY_COMPANY_NAME: 'Enter company name.',
  CHECK_SIZE_COMPANY_NAME: 'Company name must be between 3 and 30 characters.',

  AT_LEAST_ONE: '최소 하나 이상 선택해야 합니다.',
  NO_RESULT_FILE_RECEIVED: 'The result file was not delivered.',
  ENGINE_EXPIRED_LICENSE: 'Expired LicenseInfo.',
  INTERNAL_ERROR: 'Engine error.',
  PREPROCESS_FAILED: 'Preprocessing error.',
  ANALYSIS_FAILED: 'Analysis error.',
  FAIL_UPLOAD_FAILED: '파일 업로드중 에러가 발생했습니다.',
  UNDEFINED_CODE: 'Undefined code.',
  ALREADY_REGISTERED_COMPANY_ID: ' The corporation already has a registered license.',
  INVALID_PATIENT_AGE: 'Invalid Patient Age',

  INVALID_ESSENTIAL_TAG: 'Required value missing or invalid.',
  EMPTY_TO_ADDRESS: 'Enter recipient address.',
  NOT_DEFINED_EMAIL_SENDER: 'Email sender not identified.',

  SEGMENTATION_ERROR: 'Volume analysis failed',
  INCORRECT_INPUT_IMAGE: 'Volume analysis failed',
  IMAGE_FILE_LOAD_FAIL: 'Image file load failed.',
  INIT_FAIL: 'Initialization failed.',
  DATA_NOT_APPROPRIATE: 'Data is not suitable for analysis.',
  PARTIAL_SEGMENTATION_ERROR: 'Volume analysis partially failed.',
  THICKNESS_ERROR: 'Thickness analysis only failed',
  PARTIAL_SEGMENTATION_ERROR_ONLY_VOLUME: 'Volume analysis failed',
  THICKNESS_ERROR_ADD_THICK: 'Additional analysis failed (Thickness)',
  EMPTY_STORAGE_PERIOD: 'Storage 보관 기간을 입력해 주세요.',
  INVALID_PRODUCT_CODE: '제품 코드가 정확하지 않습니다.',
  PACS_DUPLICATE_DATA: 'Duplicate data.',
  GPU_OUT_OF_MEMORY: 'GPU out of memory.',
  INPUT_DATA_ERROR: 'Please check the uploaded data.',
  NOT_HEURON_SMWI: 'Invalid SMWI protocol.',

  PACS_INCONSISTENT_BIRTHDATE: 'Inconsistent birthdate.',
  EMPTY_DATE_FORMAT: '날짜 형식을 입력해주세요.',
  EMPTY_ENCODING: '인코딩 형식을 입력해주세요.',
  EMPTY_IS_SEQUENTIAL: '순차 증가 옵션을 선택해주세요.',
  EMPTY_RELAY_PACS_REPORT: 'report 자동전송 여부를 입력해주세요.',
  INVALID_DATE_FORMAT: '날짜 형식이 유효하지 않습니다.',
  STORAGE_ALMOST_FULL: '저장공간이 대부분 사용되었습니다.',
  INVALID_TO_PACS: `Incorrect To PACS value.`,
  INVALID_FROM_PACS: 'Incorrect From PACS value.',
  INVALID_FILE_COUNT: 'The number of uploaded files is out of the setting.',
  EMPTY_COMPANY_ID: '법인 ID가 없습니다.',
  EMPTY_REPORT_URL: '리포트 서버 주소가 공백입니다.',
  EMPTY_SCREENSHOT_URL: '캡처 서버 주소가 공백입니다.',
  EMPTY_CALLBACK_URL: '콜백 서버 주소가 공백입니다.',
  NOT_FOUND_MESSENGER_INFO: '메시저 정보를 찾을 수 없습니다.',
  INVALID_TIMEZONE: '유효하지 않은 타임존 입니다.',
  ALREADY_TRANSFERRED_WORKLIST: '이미 전원된 worklist 입니다.',
  NOT_COMPLETED_WORKLIST_TRANSFER: '분석 완료되지 않은 worklist는 전원이 불가합니다.',
  INVALID_TRANSFER_COMPANY_ID: '이송받을 법인 아이디가 유효하지 않습니다.',
  INVALID_DEVICE_TYPE: '모바일 디바이스 타입이 정확하지 않습니다.',
  INVALID_ATTECH_FILE: '첨부파일을 확인해 주세요.',
  NOT_COMPLETED_WORKLIST: '분석이 완료되지 않은 worklist 입니다.',
  INVALID_ENCODING: '인코딩이 유효하지 않습니다.',
  INVALID_FILE_FORMAT: '파일 포맷이 유효하지 않습니다.',
  INVALID_LANGUAGE: '언어가 유효하지 않습니다.',
  INVALID_OTP: 'Enter the correct code.',
  NOT_SETTING_PROTOCOL_TAG: 'Protocol tag setting is empty.',
  INVALID_PROTOCAL_TAG: 'Invalid Protocol tag.',
  INPUT_SERIES_TO_MANY: 'Multiple image series.',

  FOUR_D_IMAGE_NOT_SUPPORTED: '4D image not surpported.',
  INCONSISTENCY_IN_NIFTI_HEADER: 'inconsistency in nifti-header.',
  FOV_IS_GREATER_THAN_256MM: 'FOV is greater than 256mm',
  HIPPOCAMPUS_IS_NOT_RECOGNIZED: 'Hippocampus is not recognized.',
  INSTALLATION_ERROR: 'Software installation error.\nContact your administrator or S/W manufacturer.',
  OPERATION_ERROR: 'Engine operation error.\nUnable to create report.',
  LONGITUDINAL_OPERATION_ERROR: 'Longitudinal engine operation error.\nPlease check the uploaded data.',
};
